import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../features/auth/AuthProvider";
import { Spinner } from "./ui";

export function Protected({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="center-screen">
        <Spinner />
      </div>
    );
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;
  return <>{children}</>;
}
